export const NEW_USER = "NEW_USER";
export const REMOVE_USER = "REMOVE_USER";
export const LOAD_INTERN_USER = "LOAD INTERN USERS";
export const SAVE_PERSON = "SAVE_PERSON";
export const LOAD_EXTERN_USER = "LOAD EXTERN USERS";
export const LOAD_USER = "LOAD USER";
export const USER_INTERESTS = "USER_INTERESTS";
export const USER_EXPERIENCE = "USER_experience";
export const SAVE_USER_INTERESTS = "SAVE_USER_INTERESTS";
export const SAVE_USER_EXPERIENCE = "SAVE_USER_experience";
export const EXPORT_USER = "export_user";

export const EXTERN_USER_LOGIN = "EXTERN_USER_LOGIN";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_CHECKAUTH = "USER_CHECKAUTH";
export const RESETPASSWORD = "USER_RESETPASSWORD"
export const RESETPASSWORD2 = "USER_RESETPASSWORD2"

export const USER_STATE_INIT = "init";
export const USER_STATE_IDLE = "idle";
export const USER_STATE_LOADING = "loading";
export const USER_STATE_IN_PROGRESS = "in progress";
export const USER_STATE_FINISHED = "finished";
export const USER_STATE_ERROR = "error";
export const USER_STATE_RELOAD = "reload";